module.exports = __webpack_public_path__ + "static/media/10.009e4180.jpg";